// extracted by mini-css-extract-plugin
module.exports = {"container":"Messages_container__2r2qU"};